class VariantPicker extends HTMLElement {
  constructor() {
    super();

    this.options = null;
  }

  connectedCallback() {
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateOptionNames();
    this.toggleAddButton(true, '');
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
    } else {
      // this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
      .then((res) => res.text())
      .then((html) =>
        new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section')
      ).then((html) => {
      if (this.currentVariant.id !== requestedVariantId) return;

      const priceSource = html.querySelector(`#Price-${sectionId}`);
      const priceDestination = document.querySelector(`#Price-${sectionId}`);

      if (priceSource && priceDestination)
        priceDestination.innerHTML = priceSource.innerHTML;

      const addButtonUpdated = html.querySelector(
        `#ProductSubmitButton-${sectionId}`
      );
      console.log('disabled? => ', addButtonUpdated.hasAttribute('disabled'))
      this.toggleAddButton(
        addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
        'Sold out'
      );
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('fieldset')];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"]')];

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      element.classList.toggle('disabled', !availableElement);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateOptionNames() {
    if (this.currentVariant) {
      this.currentVariant.options.forEach((option, index) => {
        this.querySelector(`[data-option-${index + 1}]`).textContent = option;
      });
    }
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = 'Add to cart';
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('fieldset'),
      (element) =>
        Array.from(element.querySelectorAll('input')).find(
          (radio) => radio.checked
        )?.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false)
    );
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-picker', VariantPicker);